module.exports = "/_next/static/images/Hero@2x-7d007fca5cdd24db564701bbf999feaa.png";